import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Broadcaster } from '../app.broadcaster';
import { environment } from '../../environments/environment';
import { LoaderService } from '../loader/LoaderService';

@Injectable()
export class ProfileService {
    userToken: any;
    apiUrl = environment.apiUrl;
    onCatch: any;

    constructor(private httpClient: HttpClient, private loaderService: LoaderService,
        private router: Router, private broadcaster: Broadcaster) {
        this.logOut(false);
        this.broadcaster.broadcast('setBgOrNot', true);
    }

    pageUrlAuthorizeToAccess() {
        const paramData = this.router.parseUrl(this.router.url);
        const isExist = this.router.url.indexOf('/panno-verify');
        if (isExist !== -1 && paramData.queryParams.UserId) {

        } else if (this.router.url !== '/more/terms-n-conditions'
            && this.router.url !== '/menu/home'
            && this.router.url !== '/live-chat'
            && this.router.url !== '/more/faq'
            && this.router.url !== '/panno-verify'
            && this.router.url.indexOf('sports/contest-category') === -1
            && this.router.url.indexOf('sports/create-team') === -1
            && this.router.url.indexOf('sports/save-team') === -1
            && this.router.url !== '/more/privacy-policy') {
            this.broadcaster.broadcast('setBgOrNot', false);
            this.router.navigate(['/landing']);
            event.preventDefault();
        }
    }

    logOut(haveToLogout: boolean) {
        if (haveToLogout) {
            localStorage.removeItem('save_token');
            localStorage.removeItem('match_info');
            localStorage.removeItem('user-info');
            localStorage.removeItem('friend-list');
            localStorage.removeItem('shareLink');
            localStorage.removeItem('wallet_amount');
        }
        if (localStorage.getItem('save_token')) {
            this.userToken = JSON.parse(localStorage.getItem('save_token'));
        } else {
            this.pageUrlAuthorizeToAccess();
        }
    }

    getUserId() {
        return this.userToken.UserId;
    }

}


